import { Contract, ethers, formatUnits } from 'ethers';
import { useCallback, useMemo } from 'react';
import { attemptAggregate } from '../utils/attemptAggregate.js';
import { erc20Abi } from 'viem';
import { MULTICALL_ABI } from '../constants/abi.js';

export const useAccountBalances = (
  jsonRpcProvider
) => {
  const multicall = useMemo(
    () =>
      new ethers.Contract(
        process.env.REACT_APP_MULTICALL_CONTRACT_ADDRESS,
        MULTICALL_ABI,
        jsonRpcProvider
      ),
    [jsonRpcProvider]
  );

  const getUserTokensBalanse = useCallback(
    async (tokens, walletAddress) => {
      const tokenContract = new Contract(
        tokens[0].address,
        erc20Abi,
        jsonRpcProvider
      );

      const calls = tokens.map(token => [
        token.address,
        tokenContract.interface.encodeFunctionData('balanceOf', [
          walletAddress,
        ]),
      ]);

      const res = await attemptAggregate(multicall, calls);
      const data = res[1];

      const userTokens = [];

      data.forEach((aggregateItemResult, i) => {
        const data = tokenContract.interface.decodeFunctionResult(
          'balanceOf',
          aggregateItemResult
        );

        userTokens.push({
          ...tokens[i],
          value: parseFloat(formatUnits(data[0], tokens[i].decimals)),
        });
      });

      return userTokens;
    },
    [jsonRpcProvider]
  );

  return {
    getUserTokensBalanse,
  };
};
